export const QUICK_ACTION_LABELS = {
  copyReportId: 'Copy Report ID',
  copySchedulingUrl: 'Copy Scheduling URL',
  openDonorPass: 'Open Donor Pass ↗',
  openFinalReport: 'Open Final Report ↗',
  flaskAdmin: 'Flask-Admin report',
} as const;

export const COPY_SUCCESS = {
  reportId: 'Report ID copied',
  schedulingUrl: 'Scheduling URL copied',
} as const;
